export var CRUDPathSegmentEn;
(function (CRUDPathSegmentEn) {
    CRUDPathSegmentEn["ADD"] = "/add";
    CRUDPathSegmentEn["EDIT"] = "/edit";
    CRUDPathSegmentEn["DETAIL"] = "/detail";
    CRUDPathSegmentEn["DETAIL_BY_CODE"] = "/detail-by-code";
    CRUDPathSegmentEn["QR"] = "/qr";
})(CRUDPathSegmentEn || (CRUDPathSegmentEn = {}));
